import { Filter } from "lucide-react";
import GenericCrudModule from "@/components/GenericCrudModule";
import ContextButton from "@/components/ContextButton";

export default function MesFiltres() {
  return (
    <GenericCrudModule
      module={{
        path: "filtres", title: "Mes filtres", overline: "Opérationnel · Vues",
        subtitle: "Sauvegardez vos vues filtrées personnalisées pour retrouver rapidement vos écrans clés.",
        accent: "#7F77DD", icon: Filter, dataTestId: "filtres",
      }}
      fields={[
        { key: "nom", label: "Nom du filtre", required: true, span: 2, placeholder: "Ex : Risques critiques en cours" },
        { key: "scope", label: "Périmètre", type: "select", default: "risques",
          options: [
            { value: "risques", label: "Risques" },
            { value: "controles", label: "Contrôles" },
            { value: "incidents", label: "Incidents" },
            { value: "alertes", label: "Alertes" },
            { value: "fournisseurs", label: "Fournisseurs" },
            { value: "plans", label: "Plans d'action" },
            { value: "audits", label: "Audits" },
          ] },
        { key: "couleur", label: "Couleur", default: "#378ADD", placeholder: "#378ADD" },
      ]}
      columns={[
        { key: "nom", label: "Filtre", render: (r) => (
          <span className="flex items-center gap-2">
            <span className="w-2.5 h-2.5 rounded-full" style={{ background: r.couleur || "#378ADD" }} />
            <span className="text-white">{r.nom}</span>
          </span>
        )},
        { key: "scope", label: "Périmètre" },
      ]}
      emptyMsg="Aucun filtre sauvegardé. Créez vos vues personnalisées pour piloter plus vite."
      primaryCta="Créer un filtre"
      headerActions={<ContextButton moduleKey="filtres" />}
    />
  );
}
